<template>
  <button
    class="button"
    :class="{
      'button-primary': type === 'primary',
      'button-small': size === 'small'
    }"
    @click="handleClick"
  >
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'PubbleButton',
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.button {
  background: #ffffff;
  border: 1px solid #d2d2d9;
  border-radius: 8px;
  padding: 6px 16px;
  font-family: DiDiSans-Pro-Medium;
  font-size: 14px;
  color: #0b0b0d;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 500;
  cursor: pointer;
  text-align: center;
}

.button:hover {
  border-color: #aaaab3;
}

.button-primary {
  background: #ffd500;
  border: none;
}

.button-primary:hover {
  background: #f8e06c;
}

.button-small {
  padding: 5px 12px;
  font-size: 12px;
  line-height: 18px;
}
</style>
